import formService from "./form";

/**
 * Grafica delle pagine di prenotazione dei servizi dell'hotel: i tavoli del
 * ristorante (/ristorante), i trattamenti della SPA (/spa) e gli ombrelloni
 * della spiaggia (/spiaggia), piu' le rispettive pagine di annullamento.
 *
 * Nome, contatti, logo e sfondo sono quelli del servizio (Parametri generali del
 * ristorante, della SPA o della spiaggia in DotGuest), non quelli del Booking
 * delle camere; il colore e' quello del servizio o, se manca, quello della
 * struttura.
 *
 * E' un servizio solo perche' le pagine fanno la stessa cosa: il backend manda
 * lo stesso oggetto "grafica" da BE_ristorante, BE_spa e BE_spiaggia, e tre
 * copie di questo codice vorrebbero dire correggere tre volte lo stesso difetto.
 */
const paginaService = {
  /** Prima della risposta: niente sfondo, logo e testi del Booking. */
  neutra(vm) {
    vm.$theme.background = "";
    ["logo", "titolo", "riga1", "riga2", "riga3", "riga4", "telefono"].forEach((k) => (vm.$hotel[k] = ""));
  },
  /** Applica la grafica arrivata dal backend (BE_ristorante, BE_spa o BE_spiaggia, "grafica"). */
  applica(vm, g) {
    if (!g) {
      return;
    }
    // Logo e sfondo sono relativi alla radice del backend.
    const base = String(vm.$config.server_url || "").replace(/\/rest\/?$/, "");
    const url = (percorso) => (percorso ? base + "/" + percorso : "");
    vm.$hotel.logo = url(g.logo);
    // Senza logo il nome va a sinistra al suo posto, se no in alto a destra.
    vm.$hotel.titolo = g.logo ? "" : g.nome || "";
    vm.$hotel.riga1 = g.logo ? g.nome || "" : "";
    vm.$hotel.riga2 = g.indirizzo || "";
    vm.$hotel.riga3 = g.email || "";
    vm.$hotel.riga4 = "";
    vm.$hotel.telefono = g.telefono || "";
    vm.$theme.background = url(g.sfondo);
    if (g.colore && g.colore.length > 1) {
      vm.$theme.basecolor = g.colore;
      vm.$theme.basefore = formService.perceivedBrightness(g.colore) > 138 ? "#000000" : "#ffffff";
      vm.$theme.basedark = formService.brightness(g.colore, -50);
      vm.$theme.baselight = formService.brightness(g.colore, 50);
    }
  }
};

export default paginaService;
